export function buildShopComparisonContext(calculationData, shopId) {
  const productId = calculationData?.product?.id;
  const glassTypeId = calculationData?.glass_type?.id;
  const hardwareSetId = calculationData?.hardware_set?.id;
  const hardwareItems = calculationData?.hardware_set?.hardware_items;

  if (!productId || !glassTypeId || !hardwareSetId || !Array.isArray(hardwareItems)) {
    return null;
  }

  const body = {
    dimensions: calculationData.dimensions,
    selected: {
      glass_type_id: glassTypeId,
      hardware_set_id: hardwareSetId,
      hardware_items: hardwareItems.map((item) => ({
        mapping_id: item.mapping_id,
        hardware_item_id: item.hardware_item_id,
      })),
    },
    shop_markup: {
      markup_percentage: calculationData.shop_markup?.markup_percentage ?? '0',
      markup_amount: calculationData.shop_markup?.markup_amount ?? '0',
    },
  };

  return {
    productId,
    body,
    cacheKey: JSON.stringify({ shopId: shopId ?? null, productId, ...body }),
  };
}

export function comparisonCellKey(glassTypeId, hardwareSetId) {
  return `${glassTypeId}:${hardwareSetId}`;
}

export function indexComparisonCells(cells = []) {
  return new Map(cells.map((cell) => [
    comparisonCellKey(cell.glass_type_id, cell.hardware_set_id),
    cell,
  ]));
}

export function isSelectedComparisonCell(cell, selected) {
  return String(cell?.glass_type_id) === String(selected?.glass_type_id)
    && String(cell?.hardware_set_id) === String(selected?.hardware_set_id);
}

export function formatComparisonPrice(value) {
  return `${Number(value).toLocaleString('ru-RU')} ₽`;
}

export function formatComparisonDelta(value, selectedValue) {
  const delta = Number(value) - Number(selectedValue);
  if (delta === 0) return '0 ₽';
  return `${delta > 0 ? '+' : '−'}${Math.abs(delta).toLocaleString('ru-RU')} ₽`;
}

export function isShopComparisonResponse(value) {
  return value?.success === true
    && Array.isArray(value?.axes?.glass_types)
    && Array.isArray(value?.axes?.hardware_sets)
    && Array.isArray(value?.cells)
    && Number.isInteger(value?.selected?.dealer_customer_price);
}
